import React from "react";
import { Line } from "react-chartjs-2";
import ChartSkeleton from "./Skeleton/ChartSkeleton";

const MRRGrowthChart = ({ data, options, loading }) => {
  const mrrChartData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "MRR",
        data: [
          120000, 125000, 128000, 131000, 134000, 137000, 140000, 143000,
          146000, 149000, 152000, 155000,
        ],

        fill: false,
        backgroundColor: "rgb(75, 192, 192)",
        borderColor: "#4CAF50",
        tension: 0.1,
        pointRadius: 5,
        pointBackgroundColor: "#4CAF50",
        borderWidth: 2,
      },
    ],
  };

  const mrrChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    animations: {
      tension: {
        duration: 1000,
        easing: "linear",
        from: 1,
        to: 0,
        loop: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#555",
        },
        border: {
          display: false,
        },
      },
      y: {
        min: 0,
        max: 160000,
        ticks: {
          callback: function (value) {
            if (value === 0) return "0";
            return value.toLocaleString();
          },
          stepSize: 40000,
          color: "#555",
        },
        grid: {
          color: "rgba(0, 0, 0, 0.1)",
        },
        border: {
          display: false,
        },
      },
    },
    elements: {
      line: {
        borderCapStyle: "round",
      },
    },
  };
  return (
    <div style={{ height: "100%", width: "100%" }}>
      {loading ? (
        <ChartSkeleton />
      ) : (
        <Line
          data={mrrChartData}
          options={mrrChartOptions}
          style={{ width: "100%", height: "100%" }}
        />
      )}
    </div>
  );
};

export default MRRGrowthChart;
